import { render, staticRenderFns } from "./addAdministrator.vue?vue&type=template&id=7e6c61f6&scoped=true&"
import script from "./addAdministrator.vue?vue&type=script&lang=js&"
export * from "./addAdministrator.vue?vue&type=script&lang=js&"
import style0 from "./addAdministrator.vue?vue&type=style&index=0&id=7e6c61f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6c61f6",
  null
  
)

export default component.exports